export default __webpack_public_path__ + "static/media/businessDevelopmentManager.15ea4cae.png";